module.exports = __webpack_public_path__ + "media/app/assets/images/Arsenal-2-Pro-thumb-c83efa8558d955d6f6880ac9794f4106.jpg";